import {
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
// Third Party
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
// Models
import { QuestionResponse } from '../../models/general';
// Services
import { SharedService } from '../../services/shared.service';
import { AccountingService } from 'src/app/accounting/services/accounting.service';

@Component({
    selector: 'app-choice',
    templateUrl: './choice.component.html',
    styleUrls: ['./choice.component.scss'],
    standalone: true,
    imports: []
})
export class ChoiceComponent implements OnDestroy {
  @ViewChild('yes_no_modal', { static: false }) yes_no_modal: TemplateRef<any>;

  @Input() context: any;
  question: string;
  options: string[];
  optional_details: {};
  modal_id: number;
  reverse_btn_color: boolean = false; // change the color of the buttons based on the this var. still needs to be coded

  modalRef: BsModalRef;
  modalConfig = {
    animated: true,
  };

  yn_options: ModalOptions = {
    class: 'modal-dialog, modal-dialog-centered',
    backdrop: 'static',
    ignoreBackdropClick: true,
    keyboard: false,
  };

  constructor(
    protected element: ElementRef,
    private modalService: BsModalService,
    public sharedService: SharedService,
    private accountingService: AccountingService
  ) {
  }

  ngOnInit(): void {
    this.modal_id = this.modalService.config.id as number;    
  }

  // Closes the Modal
  closeModal() {
    const response = {'options': this.options, 'optional_details': this.optional_details};
    this.modalService.hide(this.modal_id);
  }
 cancelModal() {
    const response = {'options': this.options, 'optional_details': this.optional_details};
    this.accountingService.cancelChoice$.next(response);
    this.modalService.hide(this.modal_id);
  }
  // function used if the "Yes" button is pressed
  option1Selected() {
    let response: QuestionResponse = new QuestionResponse();
    response.answer = this.options[0]
    response.optional_details = this.optional_details;
    response.question = this.question;
    this.sharedService.option_selected$.next(response);
    this.closeModal();
  }

  // function used if the "No" button is pressed
  option2Selected() {
    let response: QuestionResponse = new QuestionResponse();
    response.answer = this.options[1]
    response.optional_details = this.optional_details;
    response.question = this.question;
    this.sharedService.option_selected$.next(response);
    this.closeModal();
  }

  ngOnDestroy() {
//    this.sub.unsubscribe();
}
}
